export const locid = (poke) => poke?.customId || poke?.location
